import {
    createSite,
    deleteSite,
    getSiteBySiteAddress,
    getSites,
    updateSite,
    getSiteCurrentPlans,
    getSitePlans,
} from "../../api/site";
import { getDomainSite, setDomainSite } from "../../utils/site";
import { createPaymentMethod, getBillingDetail, updateBilling, updateCardInfo } from "../../api/billing";
import {
    subscribePlan,
    unsubscribePlan,
    subscribePlanBySiteId,
    unsubscribePlanBySiteId,
    runningInvoice,
} from "../../api/billing";

import _ from "lodash";

const site = {
    namespaced: true,
    state: {
        site: getDomainSite(),
        sites: JSON.parse(localStorage.getItem("sites")) || {
            total: 0,
            count: 0,
            data: [],
        },
        billingDetail: null,
        currentPlans: {},
        plans: [],
        plansAvailable: false,
    },
    getters: {
        getSite: (state) => (id) => {
            return state.sites.data.find((u) => u._id === id);
        },
        isSuspend: (state) => {
            return _.get(state.site, "suspend", false);
        },
    },
    mutations: {
        SET_SITES: (state, payload) => {
            localStorage.setItem("sites", JSON.stringify(payload));
            state.sites = payload;
        },
        ADD_SITE: (state, payload) => {
            state.sites.data.push(payload);
            state.sites.total++;
        },
        UPDATE_SITE: (state, payload) => {
            let adminUser = state.sites.data.findIndex((p) => p._id === payload._id);
            state.sites.data[adminUser] = payload;
        },
        GET_SITE_BY_SITE_ADDRESS: (state, payload) => {
            state.site = payload;
        },
        REMOVE_SITE: (state, id) => {
            state.sites.data = state.sites.data.filter((u) => u._id !== id);
            state.sites.total--;
        },
        SET_CURRENT_PLANS: (state, currentPlans) => {
            state.currentPlans = currentPlans;
        },
        SET_BILLING_DETAIL: (state, billingDetail) => {
            state.billingDetail = billingDetail;
        },
        SET_SITE_PLANS: (state, plans) => {
            state.plans = plans;
        },
        SET_PLANS_AVAILABLE: (state, val) => {
            state.plansAvailable = val;
        },
    },
    actions: {
        getSites({ commit }, payload) {
            return getSites(payload.perPage, payload.page, payload.extendedMeta, payload.cache).then((response) => {
                commit("SET_SITES", response.data);
            });
        },
        getSite({ state }, id) {
            return state.sites.data.find((u) => u._id === id);
        },
        delSite({ commit }, id) {
            return deleteSite(id).then(() => {
                commit("REMOVE_SITE", id);
            });
        },
        createSite({ commit }, payload) {
            return createSite(payload).then((response) => {
                commit("ADD_SITE", response.data);
            });
        },
        updateSite({ commit }, payload) {
            return updateSite(payload._id, payload).then((response) => {
                commit("UPDATE_SITE", response.data);
            });
        },
        getSiteBySiteAddress({ commit }, payload) {
            return getSiteBySiteAddress(payload).then((response) => {
                commit("GET_SITE_BY_SITE_ADDRESS", response.data);
                setDomainSite(JSON.stringify(response.data));
                return response;
            });
        },
        getSiteCurrentPlans({ commit }) {
            return getSiteCurrentPlans().then((currentPlans) => {
                commit("SET_CURRENT_PLANS", currentPlans);
            });
        },
        getBillingDetail({ commit, state }) {
            return getBillingDetail().then((res) => {
                const billingDetail = res.data;
                commit("SET_BILLING_DETAIL", billingDetail);

                return billingDetail;
            });
        },
        createPaymentMethod({ commit }, payload) {
            return createPaymentMethod(payload).then((res) => {
                const billingDetail = res.data;
                commit("SET_BILLING_DETAIL", billingDetail);
                return res.data;
            });
        },
        updateCardInfo({ commit, state }, payload) {
            return updateCardInfo(payload).then((res) => {
                const billingDetail = res.data;
                commit("SET_BILLING_DETAIL", billingDetail);

                return billingDetail;
            });
        },
        updateBilling({ commit, state }, payload) {
            return updateBilling(payload).then((res) => {
                const billingDetail = res.data;
                commit("SET_BILLING_DETAIL", billingDetail);
                return billingDetail;
            });
        },
        getSitePlans({ commit }) {
            return getSitePlans().then((data) => {
                commit("SET_SITE_PLANS", data);
                commit("SET_PLANS_AVAILABLE", true);
                return data;
            });
        },
        subscribePlan({ commit, state }, { siteId, planId, period, details }) {
            const promise = siteId
                ? subscribePlanBySiteId(siteId, planId, period, details)
                : subscribePlan(planId, period, details);
            return promise.then((planAction) => {
                if (planAction)
                    commit("SET_CURRENT_PLANS", {
                        ...state.currentPlans,
                        [planAction.planType]: {
                            enabled: true,
                            plan: planAction,
                        },
                    });
                return planAction;
            });
        },
        unsubscribePlan({ commit, state }, { siteId, planId, planType }) {
            const promise = siteId ? unsubscribePlanBySiteId(siteId, planId) : unsubscribePlan(planId);
            return promise.then((res) => {
                const currentPlans = Object.keys(state.currentPlans)
                    .filter((key) => key == planType)
                    .reduce((acc, key) => {
                        acc[key] = state.currentPlans[key];
                        return acc;
                    }, {});
                commit("SET_CURRENT_PLANS", currentPlans);
                return res;
            });
        },
        getRunningInvoice() {
            return runningInvoice();
        },
        /*deleteAdminUser({commit}, id) {
          commit('REMOVE_ADMIN_USER', id);
          return deleteAdminUser(id);
        }*/
    },
};

export default site;
